// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contract-filter .sk-select {\n  background-color: #fff;\n  font-weight: normal;\n  font-size: 13px;\n}\n.contract-filter .sk-select__list {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.contract-filter .sk-select__value {\n  color: #333;\n  font-weight: normal;\n  font-size: 13px;\n}\n.contract-filter {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
